angular.module('satv.playlist.pitch')

.factory('PitchNote', ['config', '$resource', function(config, $resource) {
    return $resource(config.apiUri + '/playlists/pitches/notes/:id', {
        id: '@id'
    }, {});
}])

.factory('PitchNoteLoader', ['PitchNote', 'LoaderFactory', function(PitchNote, LoaderFactory) {
    return function(params) {
        return new LoaderFactory(PitchNote, params);
    };
}]);



// WEBPACK FOOTER //
// ./vendor/sonyatv/playlistpitchclientbundle/Resources/js/angular/services/PitchNote.js